module.exports = __webpack_public_path__ + "img/hair_front_female_very_short_mask.a03d491f.png";